// @flow
export default class Projection {
    /**
     * @description: 正投(子类需要实现)
     * @param {*} lnglat
     * @return {*}
     */
    project(lnglat) {
        let lng, lat;
        if (Array.isArray(lnglat)) {
            lng = lnglat[0];
            lat = lnglat[1];
        } else {
            lng = lnglat.lng;
            lat = lnglat.lat;
        }
        return [lng, lat];
    }

    /**
     * @description: 反投(子类需要实现)
     * @param {*} point
     * @return {*}
     */
    unproject(point) {
        let x, y;
        if (Array.isArray(point)) {
            x = point[0];
            y = point[1];
        } else {
            x = point.x;
            y = point.y;
        }
        return [x, y];
    }

}
